import { useState } from "react";
import { useForm } from "react-hook-form";
import { Toaster } from "react-hot-toast";
// import Resizer from "react-image-file-resizer";
import { useSelector } from "react-redux";
import logo from "../../../logo.svg";
import {
  useAddSettingsMutation,
  useSettingsQuery,
} from "../../../services/settingsApi";
import { JwtReValidate, signInUser } from "../../Utility/Auth";
import { notify } from "../../Utility/Notify";
//icons
import { IoSave } from "react-icons/io5";

const HeaderSettings = () => {
  const user = signInUser();
  const { aamarId } = user;
  const lang = useSelector((state) => state.languageReducer);

  // console.log("USER::>>", user);
  const { data: settings, isSuccess, refetch } = useSettingsQuery(aamarId);
  const [addSettings] = useAddSettingsMutation();
  const [isEcommerceToggled, setIsEcommerceToggled] = useState(false);
  const [selectedImage, setSelectedImage] = useState("image1");

  const { register, handleSubmit } = useForm();

  // Handle form submission
  const onSubmit = async (data, message) => {
    const payload = {
      ...data,
      aamarId: aamarId,
    };
    // console.log("Payload for submission:", data);
    const response = await addSettings(payload);
    // console.log("Response", response);
    if (response?.data) {
      await JwtReValidate();

      refetch();
      notify(message, "success");
    } else {
      notify("Failed to add settings.", "error");
    }
  };

  return (
    <div>
      {/* Header Settings Section */}
      <form
        style={{ marginTop: "80px" }}
        onSubmit={handleSubmit((data) =>
          onSubmit(data, "Header settings updated successfully!")
        )}
      >
        <div className="mb-4">
          <div className="d-flex justify-content-between">
            <h5 className="d-flex align-content-center gap-2">
              {/* <Icons.LayoutOutline /> */}
              Header Settings
            </h5>
          </div>
          <hr />

          {/* Header Layout Selection */}
          <div className="d-flex justify-content-between mb-4">
            <span className="d-flex align-content-center gap-2">
              Header Layout
            </span>
            <div className="image-selection d-flex gap-3">
              {[
                { key: "image1", label: "Full-Screen" },
                { key: "image2", label: "Half-Screen" },
                { key: "image3", label: "Split-Screen" },
              ].map((item, index) => (
                <div
                  key={index}
                  onClick={() =>
                    !isEcommerceToggled && setSelectedImage(item.key)
                  }
                  className={`theme-option text-center ${
                    selectedImage === item.key ? "selected" : ""
                  }`}
                  style={{
                    border:
                      selectedImage === item.key
                        ? "1px solid #F2652D"
                        : "1px solid #ccc",
                    padding: "5px",
                    cursor: isEcommerceToggled ? "not-allowed" : "pointer",
                    borderRadius: "8px",
                    opacity: isEcommerceToggled ? 0.5 : 1,
                  }}
                >
                  <img
                    src={logo}
                    alt={item.label}
                    className="theme-image mb-2"
                    style={{ width: "200px", height: "200px" }}
                  />
                  <div style={{ fontSize: "14px", color: "#333" }}>
                    {item.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Sticky Toggle */}
          <div className="row mb-2">
            <label className="col-sm-4 col-form-label">Sticky Header</label>
            <div className="col-sm-8">
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="headerSticky"
                  {...register("header.sticky")}
                />
                <label className="form-check-label" htmlFor="headerSticky">
                  Enable Sticky
                </label>
              </div>
            </div>
          </div>

          {/* Submit */}
          <div className="d-flex justify-content-end mt-4">
            <button
              type="submit"
              className="btn btn-dark d-flex justify-content-center align-items-center gap-2"
            >
              <IoSave size={16} className="me-1" />
              <span>Save</span>
            </button>
          </div>
        </div>
      </form>
      <Toaster position="bottom-right" />
    </div>
  );
};

export default HeaderSettings;
